import styled from "styled-components/macro";

export const PluginBoxContainer = styled.div`
  .plugin {
    text-align: left;
    display: block;
    width: 310px; /* Fixed width for <a> tags */
    box-shadow: var(--default-drop-shadow);
    border-radius: 16px;
    background: var(--menu-color);
    padding: 20px 20px 20px 20px;
    min-height: 180px;
    flex: 0 0 auto; /* Items will not grow or shrink, and will auto-adjust their width */
    box-sizing: border-box; /* To include padding and border in element's total width and height */
    color: var(--grey-0);
    ${({ $onboarding }) =>
      $onboarding &&
      `
      width: 100%;
    `}
    &.magnify:hover {
      transform: ${({ $onboarding }) => ($onboarding ? "none" : "scale(1.04)")};
    }

    h2 {
      margin-bottom: 3px !important;
      line-height: 1.2em;
      font-size: 18px;
      font-family: Inter;
    }

    p {
      line-height: 1.2em !important;
    }

    .header {
      padding: 0px;
      margin: 0px;
      button {
        padding: 8px 12px !important;
        border-radius: 20px !important;
        margin-top: 0px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        letter-spacing: 1px;
        transition: transform 200ms ease-in-out;
        &.add {
          color: var(--primary-cta-high-contrast) !important;
          background-color: var(--primary-cta-translucent) !important;
        }
        &.remove {
          color: #ea4713 !important;
          background-color: #ea47131a !important;
        }
      }
      display: flex;
      gap: 10px;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      &:hover {
        button {
          transform: scale(1.1);
        }
      }
    }

    .by {
      font-size: 12px;
      margin-bottom: 1em;
    }

    .meta {
      font-size: 12px;
      margin-bottom: 1em;
    }
  }
`;
